import React from "react";
import KrishnaLogo from "../Assets/KPS_Logo.png";

const PrintAdmissionForm = React.forwardRef(({ data }, ref) => {
  if (!data) return null;

  const formatDate = (date) => (date ? date.slice(0, 10) : "");
  const currentYear = new Date().getFullYear();
  const academicYear = `${currentYear}-${currentYear + 1}`;

  return (
    <>
      <style>{`@page { size: A4 portrait; margin: 6mm; }`}</style>

      <div ref={ref} className="text-[12px] font-sans text-gray-900 p-4">

        <div className="text-center border-b-2 border-dark pb-2 mb-3">
          <div className="flex justify-center items-center gap-3">
            <img src={KrishnaLogo} alt="logo" className="w-16" />
            <div>
              <h1 className="text-xl font-bold tracking-wide">
                KRISHNA PUBLIC SCHOOL
              </h1>
              <p>251, BAQAR GANJ, FATEHPUR - 212601</p>
              <p className="font-semibold">
                ADMISSION FORM FOR ACADEMIC YEAR {academicYear}
              </p>
            </div>
          </div>
        </div>

        <Title>1. Student Details</Title>
        <Grid>
          <Field label="Full Name" value={data[0].Name} />
          <Field label="Date of Birth" value={formatDate(data[0].DOB)} />
          <Field label="Gender" value={data[0].Gender} />
          <Field label="Class" value={data[0].Religion} /> 
        </Grid>

        <Title>2. Parents/Guardian Details</Title>
        <Grid>
          <Field label="Father's Name" value={data[0].FatherName} />
          <Field label="Qualification" value={data[0].FatherQualifiaction} />
          <Field label="Occupation" value={data[0].FatherOccupation} />
          <Field label="Mobile" value={data[0].Mobile} />
          <Field label="Address" value={data[0].Address} />
        </Grid>

        <Title>3. Reason for Admission</Title>
        <div className="border border-dark p-2 mt-1 min-h-[40px]">{data[0].Reason}</div>

        <Title>4. Declaration</Title>
        <p className="mt-2 text-[11px] leading-relaxed">
          I hereby declare that the above information is true and correct to the
          best of my knowledge.
        </p>

        <div className="flex justify-between mt-14 text-center">
          <div>
            <div className="border-t w-40 mx-auto"></div>
            Parent Signature
          </div>
          <div>
            <div className="border-t w-40 mx-auto"></div>
            Principal Signature
          </div>
        </div>

      </div>
    </>
  );
});

export default PrintAdmissionForm;


const Title = ({ children }) => (
  <h2 className="mt-4 font-semibold border-b border-dark pb-1">{children}</h2>
);

const Grid = ({ children }) => (
  <div className="grid grid-cols-2 gap-x-6 gap-y-2 mt-2">{children}</div>
);

const Field = ({ label, value }) => (
  <div className="flex justify-between border-b border-dark pb-1">
    <span className="text-gray-600">{label}</span>
    <span className="font-medium">{value || "-"}</span>
  </div>
);
